var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipchamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 1h10v14H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1H5v14h10V1zM5 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H5z",
    fill: "#605E5C"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.577 3.698.497 5.32a.637.637 0 0 0-.48.764l.19.814c.079.343.424.557.77.478l7.079-1.622a.637.637 0 0 0 .481-.764l-.19-.814a.642.642 0 0 0-.77-.478z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.638h9v1.217a.817.817 0 0 1-.818.812H.818A.817.817 0 0 1 0 11.855v-1.217z",
    fill: "#5A4CDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.608H2.863v2.03H9v-2.03z",
    fill: "#885EDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.136 6.58H0v2.028h6.136V6.58z",
    fill: "#C689E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.864 8.608H0v2.03h2.864v-2.03zM6.137 6.58h2.045c.45 0 .818.364.818.81v1.218H6.137V6.58z",
    fill: "#AA72E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10v.637h.642A.638.638 0 0 1 0 10z",
    fill: "#5A4CDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.972v.637h.642A.638.638 0 0 1 0 7.972z",
    fill: "#AA72E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.942v.637h.642A.638.638 0 0 1 0 5.942z",
    fill: "#C689E6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.182 6.58H.642A.64.64 0 0 1 0 5.941v5.913c0 .446.368.811.818.811h7.364c.45 0 .818-.365.818-.811V7.39a.817.817 0 0 0-.818-.812z",
    fill: "url(#d)",
    style: {
      mixBlendMode: "soft-light"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.128,
    y1: 5.463,
    x2: 5.258,
    y2: 9.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD58DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 5.942,
    x2: 10.046,
    y2: 10.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4CDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 3.333)",
    d: "M0 0h9v9.333H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipchamp);
export default __webpack_public_path__ + "static/media/clipchamp.718ceb0362d452a555d5bd6b19c1d7e1.svg";
export { ForwardRef as ReactComponent };